import { render, staticRenderFns } from "./centerde-used.vue?vue&type=template&id=ca13f32c&scoped=true"
import script from "./centerde-used.vue?vue&type=script&lang=js"
export * from "./centerde-used.vue?vue&type=script&lang=js"
import style0 from "./centerde-used.vue?vue&type=style&index=0&id=ca13f32c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca13f32c",
  null
  
)

export default component.exports